import toasts from "../../../mixins/toasts";

export default {
    mixins: [toasts],
    methods: {
        archive(user) {
            let message =
                `Вы уверены, что хотите архивировать пользователя ` +
                `<b>${user.full_name}</b>?`;

            if (user.type == "student") {
                message =
                    `Вы уверены, что хотите отчислить студента ` +
                    `<b>${user.full_name}</b>?` +
                    `<br><br><b>Внимание:</b><br>Студент будет исключен из всех групп!`;
            }

            this.$dialog.confirm({
                title:
                    user.type == "student"
                        ? "Отчисление студента"
                        : "Архивирование пользователя",
                message: message,
                confirmText:
                    user.type == "student"
                        ? "Отчислить студента"
                        : "Архивировать пользователя",
                cancelText: "Отмена",
                type: "is-warning",
                hasIcon: true,
                onConfirm: () => {
                    let loading = this.$loading.open();

                    axios
                        .post(`/api/users/${user.id}/archive`, user)
                        .then(response => {
                            this.toast(
                                "success",
                                user.type == "student"
                                    ? "Студент был успешно отчислен"
                                    : "Пользователь был успешно архивирован"
                            );
                            _.delay(() => {
                                location.reload();
                            }, 2000);
                        })
                        .catch(error => {
                            this.toast("error", "@unexpected", error);
                            loading.close();
                        });
                }
            });
        },
        restore(user) {
            this.$dialog.confirm({
                title: "Восстановление пользователя",
                message:
                    `Вы уверены, что хотите восстановить пользователя ` +
                    `<b>${user.full_name}</b>?`,
                confirmText: "Восстановить пользователя",
                cancelText: "Отмена",
                type: "is-success",
                hasIcon: true,
                onConfirm: () => {
                    let loading = this.$loading.open();

                    axios
                        .post(`/api/users/${user.id}/restore`, user)
                        .then(response => {
                            this.toast("success", "Пользователь был успешно восстановлен");
                            _.delay(() => {
                                location.reload();
                            }, 2000);
                        })
                        .catch(error => {
                            this.toast("error", "@unexpected", error);
                            loading.close();
                        });
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/views/users/mixins/archives-users.js